import {config} from '../config/config'

export const themes = config.themes
